import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ProfileLevel } from '@enums/acl/resources.enum';
import { environment } from '@environments/environment';
import { LanguageHelper } from '@helpers/language-helper.service';
import { UserHelperService } from '@helpers/user-helper.service';
import { AuthenticationService } from '@modules/authentication/authentication.service';
import { UserPreferencesService } from '@modules/users/user.preferences.service';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@node_modules/@angular/platform-browser';
import { firstValueFrom } from '@node_modules/rxjs';
import { ParametersHttpService } from '@services/parameters/parameters-http.service';
import { CookieService } from 'ngx-cookie-service';
import { filter } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppInitializerService } from './initializers/app-initializer.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'omnismart';
  constructor(
    private _translateService: TranslateService,
    private languageHelper: LanguageHelper,
    private readonly cookieService: CookieService,
    private readonly titleService: Title,
    private readonly router: Router,
    private parametersService: ParametersHttpService,
    private readonly activatedRoute: ActivatedRoute,
    private userHelper: UserHelperService,
    private userPreferencesService: UserPreferencesService,
    private authService: AuthenticationService,
    private appInitializerService: AppInitializerService
  ) {}

  ngOnInit(): void {
    this._translateService.addLangs(this.languageHelper.getAllLanguageIds());
    this._translateService.setDefaultLang(this.languageHelper.defaultLanguageId);
    this._translateService.use(this.languageHelper.getCurrentLanguageId());

    const appTitle = this.titleService.getTitle();
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(async () => {
          let child = this.activatedRoute.firstChild;
          while (child?.firstChild) {
            child = child.firstChild;
          }

          if (child) {
            if (child.snapshot.data['title']) {
              return `${await firstValueFrom(this._translateService.get(child.snapshot.data['title']))} | Omnismart`;
            }
          }

          return appTitle;
        })
      )
      .subscribe(async (ttl: Promise<string>) => {
        this.titleService.setTitle(await ttl);
      });

    this.initJitsiMeetApi();
  }

  private initJitsiMeetApi() {
    const scriptElement = document.createElement('script');

    scriptElement.setAttribute('src', `${environment.OMNISMART_API_JITSI_MEET}external_api.js`);

    document.head.appendChild(scriptElement);
  }

  public async redirectHomePage(): Promise<void> {
    const userAttr = this.userHelper.getUserAttributes();

    if ((userAttr?.level ?? ProfileLevel.LOW) <= ProfileLevel.LOW) {
      await this.router.navigate(['/panel/dashboard']);
      return;
    }

    await this.router.navigate(['/panel']);
  }
}
